const initialState = {
	data: [],
	total: 0,
	params: {},
	selectedAffiliate: {},
	sidebarOpen: false,
	sidebarStatus: 'add',
}

const affiliate = (state = initialState, action) => {
	switch (action.type) {
		case 'AFFILIATE_GET_DATA':
			return {
				...state,
				data: action.data,
				total: action.total,
				params: action.params,
			}
		case 'AFFILIATE_DEL_DATA':
			return {
				...state,
				data: state.data.filter((item) => item.id !== action.index),
				total: state.total - 1,
			}
		case 'AFFILIATE_ADD_DATA':
			return {
				...state,
				data: [...state.data, action.data],
				total: state.total + 1,
			}
		case 'AFFILIATE_UPDATE_DATA':
			const updatedData = state.data.map((item) => (item.id === action.index ? action.data : item))
			return {
				...state,
				data: updatedData,
			}
		case 'AFFILIATE_GET_CURRENT':
			return {
				...state,
				selectedAffiliate: action.selectedAffiliate,
			}
		case 'AFFILIATE_SET_SIDEBAR':
			return {
				...state,
				sidebarStatus: action.status,
				sidebarOpen: !state.sidebarOpen,
			}
		default:
			return state
	}
}

export default affiliate
